import { render, staticRenderFns } from "./MemorialHallUpgrade.vue?vue&type=template&id=441cfc45&scoped=true"
import script from "./MemorialHallUpgrade.vue?vue&type=script&lang=js"
export * from "./MemorialHallUpgrade.vue?vue&type=script&lang=js"
import style0 from "./MemorialHallUpgrade.vue?vue&type=style&index=0&id=441cfc45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441cfc45",
  null
  
)

export default component.exports